import {
  Dialog,
  Box,
  DialogTitle,
  Select,
  DialogContent,
  FormControl,
  InputLabel,
  ThemeProvider,
  ListItemText,
  MenuItem,
  Button,
  DialogActions,
  SelectChangeEvent,
} from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import {
  customDialogRegroupParcelsTheme,
  SelectParcelTheme,
} from 'assets/styles/themes/Dialog/generic_dialog_regroup_parcel';
import { customButtonTheme } from 'assets/styles/themes/generic_button_mui';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getParcelsByExploitation, logToIniateProcedure } from 'services/API/Exploitation';
import { displayErrorMessage } from 'utils/tools_functions';
import { toast } from 'react-toastify';
import { ExploitationContext } from 'utils/context';

type ProcedureCampaignModalParams = {
  modalProcedure: boolean;
  setModalProcedure: (value: boolean) => void;
  possibleCampaign: { startYear: number; endYear: number; stringFormat: string }[];
  setModalOvertakeProcedure: (value: boolean) => void;
  willOvertakeProcedure: boolean;
  setWillOvertakeProcedure: (value: boolean) => void;
};
const ProcedureCampaignModal = ({
  modalProcedure,
  setModalProcedure,
  possibleCampaign,
  setModalOvertakeProcedure,
  willOvertakeProcedure,
  setWillOvertakeProcedure,
}: ProcedureCampaignModalParams) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [selectedValue, setSelectedValue] = useState<string>('');
  const { setExploitationContext } = useContext(ExploitationContext);

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedValue(event.target.value);
  };
  const onSubmit = async () => {
    setModalProcedure(false);
    try {
      const result = await logToIniateProcedure(
        'exploitation',
        Number(localStorage.getItem('exploitation')),
        willOvertakeProcedure,
      );
      if (result !== undefined) {
        const response = await getParcelsByExploitation(
          Number(localStorage.getItem('exploitation')),
          selectedValue,
        );

        const nextCampaignChosen = possibleCampaign?.find(
          (campaign) => campaign?.stringFormat === selectedValue,
        );

        setExploitationContext((prevContext: any) => ({
          ...prevContext,
          parcels: response.data.data,
        }));
        navigate(`/exploitation/campaign`, {
          state: { nextCampaignChosen },
        });
        setWillOvertakeProcedure(false);
      }
    } catch (error: any) {
      // console.error('error', error.response.data.data.error_type);
      const errorData = error.response?.data?.data;
      if (errorData?.error_type === 'ERR_CAN_TAKEOVER') {
        setModalOvertakeProcedure(true);
      }
      toast.error(displayErrorMessage(errorData?.error_type, errorData));
    }
  };
  return (
    <ThemeProvider theme={customDialogRegroupParcelsTheme}>
      <Dialog
        maxWidth="lg"
        fullWidth
        open={modalProcedure}
        onClose={() => setModalProcedure(false)}
      >
        <Box>
          <DialogTitle>{t('title.procedureCampaignChange')}</DialogTitle>
          <ClearIcon onClick={() => setModalProcedure(false)} />
        </Box>
        <DialogContent className="dialogcontent-select-parcel">
          <InputLabel id="MainParcel">{t('label.availableCampaigns')}</InputLabel>
          <FormControl sx={{ width: '100%' }} variant="filled">
            <ThemeProvider theme={SelectParcelTheme}>
              <InputLabel id="selectParcel">{t('label.chooseCampaign')}</InputLabel>
              <Select onChange={handleChange}>
                {possibleCampaign.map((campaign) => (
                  <MenuItem key={campaign?.stringFormat} value={campaign?.stringFormat}>
                    <ListItemText primary={campaign.stringFormat} />
                  </MenuItem>
                ))}
              </Select>
            </ThemeProvider>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <ThemeProvider theme={customButtonTheme}>
            <Button id="inputCostButton" disabled={!selectedValue} onClick={onSubmit}>
              {t('common.validate')}
            </Button>
          </ThemeProvider>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default ProcedureCampaignModal;
